export default function getUrl(value: string) {
  try {
    if (!value.startsWith("http://") && !value.startsWith("https://")) {
      return new URL(`https://${value}`);
    }

    return new URL(value);
  } catch {
    return null;
  }
}
